import { Flex } from '@chakra-ui/react';
import { FixtureListGrid } from '@/components/FixtureListGrid';
import { MatchdayResultsList } from '@/components/MatchdayResultsList';
import type { Fixture } from '@/models/fixture';
import type { gameResult } from '@/models/gameUpdate';
import type { LiveMatch } from '@/models/liveMatch';
import { ScoresListCard } from './ScoresListCard';

export function TournamentStagePanel(props: {
  variant: 'fixtures' | 'results';
  fixturesForDisplay: Fixture[];
  liveMatches: LiveMatch[];
  gameResults: gameResult[];
  scrollContained: boolean;
  cardRadius: number | undefined;
}) {
  const { variant, fixturesForDisplay, liveMatches, gameResults, scrollContained, cardRadius } = props;

  if (variant === 'fixtures') {
    return (
      <Flex direction='column' w='full' minH={scrollContained ? 0 : undefined}>
        <ScoresListCard
          title='Fixtures'
          emptyMessage='No upcoming fixtures.'
          isEmpty={fixturesForDisplay.length === 0}
          scrollContained={scrollContained}
          borderRadius={cardRadius}
        >
          <FixtureListGrid fixtureList={fixturesForDisplay} liveMatches={liveMatches} svg />
        </ScoresListCard>
      </Flex>
    );
  }

  return (
    <Flex direction='column' w='full' minH={scrollContained ? 0 : undefined}>
      <ScoresListCard
        title='Results'
        emptyMessage='No results yet.'
        isEmpty={gameResults.length === 0}
        scrollContained={scrollContained}
        borderRadius={cardRadius}
      >
        <MatchdayResultsList results={gameResults} svg />
      </ScoresListCard>
    </Flex>
  );
}
